import React, { useState, useEffect, Fragment } from "react";
import { Link, useStaticQuery, graphql } from "gatsby"
import { useLocation } from '@reach/router';
import * as SunCalc from 'suncalc';

const Navigation = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isExpanded, toggleExpansion] = useState(false)

  const nav = useStaticQuery(graphql`
    query {
      allStrapiNavigation(sort: {order: ASC}) {
        nodes {
          id
          title
          path
          type
          menuAttached
          related {
            id
            publishedAt
          }
          items {
            id
            title
            path
            type
            menuAttached
            related {
              publishedAt
              id
            }
          }
        }
      }
    }
  `)
  console.log(nav)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.weather.gov/gridpoints/HGX/57,107/forecast/hourly'); // Replace with your API endpoint
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only once on mount

  const location = useLocation();

  // if (loading) return <p>Loading data...</p>;
  if (error) return <p>Error: {error.message}</p>;

  function handleBreaks(str, hide) {
    // Split by literal backslash
    const parts = str.split(/\\+/);

    if (hide) {
      // Join back into a single string, removing the backslashes
      return parts.join(' ');
    }

    // Interleave strings with <br /> elements
    return parts.map((part, index) => (
      <Fragment key={index}>
        {part}
        {index < parts.length - 1 && <br />}
      </Fragment>
    ));
  }
  // get today's sunlight times for London
  var times = SunCalc.getTimes(new Date(), 30.06145603439729, -95.49565944146424);


  return (
    <nav>
      <div className={`${isExpanded ? `block` : `hidden`} z-40 w-screen h-screen h-dvh bg-bggreen text-bgmint fixed top-0 left-0 `} >
        <div className="h-screen py-28 px-12 overflow-y-scroll text-5xl flex flex-col gap-12">
          <Link onClick={() => toggleExpansion(false)} className="block" to="/">HOME</Link>
          <Link onClick={() => toggleExpansion(false)} className="block" to="/frequently-asked-questions">FAQ</Link>
          <Link onClick={() => toggleExpansion(false)} className="block" to="/food-trucks">FOOD TRUCKS</Link>
          <Link onClick={() => toggleExpansion(false)} className="block" to="/dog-park-etiquette">DOG PARK ETIQUETTE</Link>
          {nav.allStrapiNavigation.nodes.map(item => {
            return item.menuAttached && item.type === "INTERNAL" ? (<Link onClick={() => toggleExpansion(false)} className="block uppercase" to={item.path}>{handleBreaks(item.title, true)}</Link>
            ) : (<></>)
          })}
          <Link onClick={() => toggleExpansion(false)} className="block" to="/pavilion-rentals">BOOK YOUR NEXT EVENT</Link>
          <Link onClick={() => toggleExpansion(false)} className="block" to="/work-with-us">WORK WITH US</Link>
          <Link onClick={() => toggleExpansion(false)} className="block" to="/contact-park-management">CONTACT PARK MANAGEMENT</Link>
          {/* <Link onClick={() => toggleExpansion(false)} className="block" to="/pavilion-rentals">BOOK YOUR NEXT EVENT</Link> */}
        </div>
      </div>
      <div className={`
        relative container max-w-8xl pt-8 mx-auto px-4 lg:flex justify-between z-1 font-[400]
        ${location.pathname == "/" ? "text-white" : "text-stone-800"} font-300 text-sm xl:text-lg !leading-none`}>
        <div className="w-64">
          <a className="block font-[300] text-xs mb-2 -mt-6 " target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61578956278805">Follow us on Facebook</a>
          <Link to="/">
            <svg fill="currentColor" className="h-16 w-64 mr-auto">
              <use xlinkHref={`#logo`}></use>
            </svg>
          </Link>
        </div>
        <Link className="hidden lg:inline-block" to="/frequently-asked-questions">FAQ</Link>
        <Link className="hidden lg:inline-block text-center" to="/food-trucks">FOOD<br />TRUCKS</Link>
        <Link className="hidden lg:inline-block text-center" to="/dog-park-etiquette">DOG PARK<br />ETIQUETTE</Link>
        {nav.allStrapiNavigation.nodes.map(item => {
          return item.menuAttached && item.type === "INTERNAL" ? (<Link className="hidden lg:inline-block text-center uppercase" to={item.path}>{handleBreaks(item.title, false)}</Link>
          ) : (<></>)
        })}
        <Link className="hidden lg:inline-block text-center" to="/pavilion-rentals">BOOK YOUR<br />NEXT EVENT</Link>
        <Link className="hidden lg:inline-block text-center" to="/work-with-us">WORK<br />WITH US</Link>
        <Link className="hidden lg:inline-block text-center" to="/contact-park-management">CONTACT PARK<br />MANAGEMENT</Link>
        {/* MOBILE MENU BUTTON */}
        <div className="fixed right-4 top-0 z-50 lg:hidden">
          <button
            onClick={() => toggleExpansion(!isExpanded)}
            className="px-3 pt-8 pb-6 text-neutral-300 hover:text-neutral-100 bg-neutral-100 rounded-b-full"
          >
            <span className={`${isExpanded ? `translate-y-2 rotate-45` : ` `} transition-all block w-6 h-1 border-bggreen border-b-2`}></span>
            <span className={`${isExpanded ? `!w-0 translate-x-3` : ` `} transition-all block mt-1 w-6 h-1 border-bggreen border-b-2`}></span>
            <span className={`${isExpanded ? `-translate-y-2 -rotate-45` : ` `} transition-all block mt-1 w-6 h-1 border-bggreen border-b-2`}></span>
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
